import httpClient from '../httpClient';

export const getAddressList = async (idCustomer, addressType) => {
  const result = await httpClient.get('/payment/get-address', {
    params: {
      idCustomer: idCustomer,
      addressType: addressType,
    },
  });
  return result.data;
};
export const addAddress = async (addressInfo) => {
  const result = await httpClient.post('/payment/add-address', {
    addressInfo,
  });
  return result.data;
};
export const removeAddress = async (idAddr) => {
  const result = await httpClient.post('/payment/remove-address', {
    idAddr,
  });
  return result.data;
};
export const removePaymentMethod = async (idCC) => {
  const result = await httpClient.post('/payment/remove-payment-method', {
    idCC,
  });
  return result.data;
};

export const getPaymentMethodList = async (idCustomer) => {
  const result = await httpClient.get('/payment/get-payment-method', {
    params: {
      idCustomer: idCustomer,
    },
  });
  return result.data;
};
export const addPaymentMethod = async (idCustomer, entity) => {
  const result = await httpClient.get('/payment/add-payment-method', {
    params: {
      idCustomer,
      entity,
    },
  });
  return result.data;
};

export const placeOrder = async (data) => {
  const result = await httpClient.get('/payment/place-order', {
    params: {
      data: data,
    },
  });
  return result.data;
};

export const getPaymentTerm = async (idCustomer) => {
  const result = await httpClient.get('/payment/get-payment-term', {
    params: {
      idCustomer: idCustomer,
    },
  });
  return result.data;
};
